(() => {
  if (customElements.get('connabis-contact')) return;
  class ConnabisContact extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      const copy = this.querySelector('[data-copy-phone]');
      if (copy) {
        copy.hidden = false;
        copy.addEventListener('click', async () => {
          const phone = this.querySelector('.cb-contact-phone');
          const status = this.querySelector('.cb-contact-copy-status');
          try {
            await navigator.clipboard.writeText(phone.textContent.trim());
            status.textContent = this.dataset.copySuccess;
            copy.textContent = this.dataset.copiedLabel;
          } catch {
            if (!this.isConnected) return;
            const range = document.createRange();
            range.selectNodeContents(phone);
            const selection = window.getSelection();
            selection.removeAllRanges();
            selection.addRange(range);
            status.textContent = this.dataset.copyFallback;
          }
        }, options);
      }
      this.querySelectorAll('[data-open-inbox]').forEach(button => {
        button.hidden = false;
        button.addEventListener('click', async () => {
          const status = button.parentElement.querySelector('.cb-contact-inbox-status');
          button.disabled = true;
          status.textContent = this.dataset.inboxLoading;
          const started = Date.now();
          try {
            let chat;
            while (this.isConnected && !this.abort.signal.aborted && Date.now() - started < 8000) {
              chat = document.querySelector('shopify-chat');
              if (typeof chat?.open === 'function' || typeof chat?.open === 'boolean') break;
              await new Promise(resolve => setTimeout(resolve, 150));
            }
            if (!this.isConnected || this.abort.signal.aborted) return;
            if (typeof chat?.open === 'function') await chat.open();
            else if (typeof chat?.open === 'boolean') chat.open = true;
            else throw new Error('Inbox unavailable');
            status.textContent = '';
          } catch {
            if (this.isConnected) status.textContent = this.dataset.inboxFallback;
          } finally {
            button.disabled = false;
          }
        }, options);
      });
    }
    disconnectedCallback() { this.abort?.abort(); }
  }
  customElements.define('connabis-contact', ConnabisContact);
})();
